import Typo from '@/ui/typo/Typo';
import { Container, ChartWrapper, TitleWrapper, Title } from './EsgRiskExposure.styles';
import { COLORS } from '@/styles/colorTheme';
import { useTranslation } from 'react-i18next';
import RiskBarChart from '@/ui/charts/horizontalBarChart/RiskBarChart';

const EsgRiskExposure = ({ data, isLoading = true }) => {
  const [t] = useTranslation('dashboard');

  return (
    <div className="border rounded-lg p-4 h-full space-y-6">
      <TitleWrapper>
        <Title>
          <div className="text-text-500">{t('ESG Risk Exposures')}</div>
          <div className="text-text-200 text-sm">
            {t('Companies on my watchlist with high exposure to ESG risks and the proportion.')}
          </div>
        </Title>
      </TitleWrapper>
      <ChartWrapper>
        <RiskBarChart data={data} isLoading={isLoading} title="" />
      </ChartWrapper>
      {/* {!isLoading && data?.values.length < 5 ? (
        <div style={{ marginLeft: '10px', textAlign: 'right' }}>
          <Typo variant="caption2" color={COLORS.Background300}>
            Please follow more comapnies.
          </Typo>
        </div>
      ) : null} */}
    </div>
  );
};

export default EsgRiskExposure;
